export function coastFI(proj, targetAge, swr, ret) {
  if (!proj.length) return null;
  const finalLiv = proj[proj.length - 1]?.liv || 40000;
  const fiTarget = finalLiv / swr;
  for (let i = 0; i < proj.length; i++) {
    const d = proj[i];
    const yearsToTarget = targetAge - d.a;
    if (yearsToTarget <= 0) continue;
    const futureVal = d.liq * Math.pow(1 + ret, yearsToTarget);
    if (futureVal >= fiTarget) return d.a;
  }
  return null;
}
